import React from "react";
import { classNames } from "../styles/classNames";

interface IconButtonProps extends React.ComponentProps<"button"> {
  /** The accessible name; icon-only buttons have no other text. */
  label: string;
}

export default function IconButton({ label, className, type = "button", ...props }: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      className={classNames(
        "app-icon-button disabled:cursor-not-allowed disabled:opacity-40",
        className
      )}
      {...props}
    />
  );
}
